const Marquee = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="overflow-hidden whitespace-nowrap group">
      <div className="animate-marquee group-hover:pause">{children}</div>
    </div>
  );
};

export default Marquee;
